/**
 * TourResumeModal
 *
 * Shown on app load when user has an incomplete tour.
 */

import { Button } from "@/components/ui/button"
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog"
import { useTranslation } from "@/language"

interface TourResumeModalProps {
  open: boolean
  onResume: () => void
  onSkip: () => void
}

export function TourResumeModal({ open, onResume, onSkip }: TourResumeModalProps) {
  const { t } = useTranslation("dashboard")

  return (
    <Dialog open={open} onOpenChange={() => {}}>
      <DialogContent
        className="sm:max-w-[640px] p-5 py-10"
        showCloseButton={false}
        preventCloseOnOutsideClick
      >
        <DialogHeader>
          <DialogTitle className="text-center text-2xl">{t("tour.resumeTitle")}</DialogTitle>
          <DialogDescription className="text-center text-[14px]">
            <p>{t("tour.resumeUnfinished")}</p>
            <p>{t("tour.resumeQuestion")}</p>
          </DialogDescription>
        </DialogHeader>
        <div className="flex flex-col md:flex-row items-center justify-center gap-4 mt-2">
          <Button
            variant="outline"
            onClick={onSkip}
            className="w-full md:w-[180px] focus:outline-none focus:ring-0 focus-visible:outline-none focus-visible:ring-0 focus-visible:ring-offset-0"
          >
            {t("tour.skip")}
          </Button>
          <Button onClick={() => onResume()} className="w-full md:w-[180px]">
            {t("tour.resume")}
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  )
}
